import { render, staticRenderFns } from "./returnorderdetails.vue?vue&type=template&id=d120b5f6&scoped=true&"
import script from "./returnorderdetails.vue?vue&type=script&lang=js&"
export * from "./returnorderdetails.vue?vue&type=script&lang=js&"
import style0 from "./returnorderdetails.vue?vue&type=style&index=0&id=d120b5f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d120b5f6",
  null
  
)

export default component.exports